import { addMissingFields } from "./addMissingFields";
import { firestoreAutoId } from "./firestoreAutoId";

export async function getExcelChecklistRows(
  importData,
  importFields,
  editSchema,
  requiredFds,
  nextNo
) {
  //check for required name field
  requiredFds.forEach((rd) => {
    const nameFld = importFields.find((f) => f.selected === rd);
    if (nameFld === undefined) {
      throw new Error(`${rd} field is required`);
    }
  });

  var newEquip = [];

  const typeField = editSchema.find((f) => f.name === "Row Type");
  importData.forEach((e) => {
    var row = {};
    importFields.forEach((fd) => {
      if (fd["selected"] !== "New Attribute") {
        if (
          fd["selected"] === "Row Type" &&
          !typeField.selectables.includes(e[fd["name"]].toString())
        ) {
          row[fd["selected"]] = "Text";
        } else {
          row[fd["selected"]] = e[fd["name"]].toString();
        }
      }
    });
    row.id = firestoreAutoId();
    row = addMissingFields(row, editSchema);

    newEquip.push(row);
  });

  newEquip.forEach((feat) => {
    feat.Selected = false;
    feat.No = nextNo;
    nextNo += 1;
  });

  return newEquip;
}
